import Input from '@/components/common/Input';
import styled from '@emotion/styled';

export const FormWrapper = styled.form``;

export const StyledInput = styled(Input)`
  background-color: red;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.neutral[700]};
  font-size: 28px;
  font-weight: 700;
  height: 32px;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`;

export const Guide = styled.div`
  color: ${({ theme }) => theme.colors.neutral[500]};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 24px;
`;

export const FindPasswordWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const FindPasswordBtn = styled.button`
  background-color: transparent;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
`;

export const FindPasswordText = styled.span`
  color: #999;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
